import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/static/onboarding/astronaut.png'


const _withScopeId = n => (_pushScopeId("data-v-4a281cfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CropperImageInput = _resolveComponent("CropperImageInput")!
  const _component_MessageBox = _resolveComponent("MessageBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isInputImageOpened)
      ? (_openBlock(), _createBlock(_component_CropperImageInput, {
          key: 0,
          "image-url": $setup.newUser.image,
          onCroppedImageUrl: _cache[0] || (_cache[0] = ($event: any) => ($setup.getCroppedImageUrl($event)))
        }, null, 8, ["image-url"]))
      : _createCommentVNode("", true),
    _createVNode(_component_MessageBox, {
      class: _normalizeClass(['layout__message', { reverse: $props.animationIsReverse }]),
      message: $props.message
    }, null, 8, ["class", "message"]),
    _createElementVNode("div", {
      class: _normalizeClass(['layout__div-absolute', { reverse: $props.animationIsReverse }])
    }, [
      _createElementVNode("button", {
        class: "container-pic",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openInputImage()))
      }, [
        _createElementVNode("img", {
          id: "profile_pic",
          class: "container-pic__image",
          src: 
            $setup.newUser.image
              ? $setup.newUser.image
              : '../../../../assets/static/onerror-user.png'
          ,
          alt: $setup.newUser.name,
          onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.loadFallbackImage && $setup.loadFallbackImage(...args))),
          "data-profile-image": ""
        }, null, 40, _hoisted_2)
      ])
    ], 2),
    _createElementVNode("img", {
      class: _normalizeClass([
        'layout__astronaut',
        { 'fluctuate-facing-right': $setup.isTransitionFinished },
        { reverse: $props.animationIsReverse }
      ]),
      src: _imports_0,
      alt: "Astronauta",
      onAnimationend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.fluctuate && $setup.fluctuate(...args)))
    }, null, 34),
    _createElementVNode("div", {
      class: _normalizeClass(['layout__banner', { reverse: $props.animationIsReverse }])
    }, " Hora de decolar! ", 2)
  ]))
}